'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["contextualNodeAttributes"];
import tinymce from 'tinymce';
import RotationAngleToolbarControl from 'rich-text-lib/components/toolbar/RotationAngleToolbarControl';
import { CANVAS_ROTATION } from '../../../constants/toolbar';
import { jsx as _jsx } from "react/jsx-runtime";
export function addContextualRotationControl(editor) {
  const handleRotationChange = (target, rotationAngle) => {
    editor.fire('hsRotationAngleChange', {
      target,
      rotationAngle
    });
  };
  tinymce.canvas.addButton(editor, CANVAS_ROTATION, {
    renderControl: props => {
      const {
          contextualNodeAttributes
        } = props,
        rest = _objectWithoutPropertiesLoose(props, _excluded);
      const {
        rotationAngle,
        activeElement
      } = contextualNodeAttributes;
      return /*#__PURE__*/_jsx(RotationAngleToolbarControl, Object.assign({}, rest, {
        "data-test-id": CANVAS_ROTATION,
        rotationAngle: rotationAngle,
        onChange: handleRotationChange.bind(null, activeElement)
      }));
    }
  });
}